import { createFileRoute } from '@tanstack/react-router'
import { ImportDashboardPage } from '../../../components/imports/ImportDashboardPage'

export const Route = createFileRoute('/$org/imports/$importUid')({
    component: ImportDashboardRoute,
})

function ImportDashboardRoute() {
    return <ImportDashboardPage />
}
